export default function basicHandleActionsWithFullState(handlers, defaultState) {
  return function (state, action, fullState) {
    if (state === void 0) {
      state = defaultState;
    }

    var type = action.type;
    var handler = handlers[type];

    if (handler) {
      return handler(state, action, fullState);
    } else {
      return state;
    }
  };
}